import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const MatchHeader = ({ match, timeRemaining, autoLockHours }) => {
  const formatTimeRemaining = (milliseconds) => {
    if (milliseconds <= 0) return 'Predictions Locked';
    
    const hours = Math.floor(milliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
    
    if (hours > 0) {
      return `${hours}h ${minutes}m remaining`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s remaining`;
    } else {
      return `${seconds}s remaining`;
    }
  };

  const isLocked = timeRemaining <= 0;

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4 md:p-6 lg:p-8 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 md:gap-6">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-3 md:mb-4">
            <Icon name="Trophy" size={20} className="text-primary" />
            <span className="text-sm md:text-base text-muted-foreground font-medium">
              {match?.tournament}
            </span>
          </div>
          
          <div className="flex items-center justify-between gap-4 md:gap-6 mb-4 md:mb-6">
            <div className="flex-1 text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 mx-auto mb-2 md:mb-3 rounded-full overflow-hidden bg-muted">
                <Image 
                  src={match?.team1?.flag} 
                  alt={match?.team1?.flagAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground">
                {match?.team1?.name}
              </h3>
            </div>
            
            <div className="flex flex-col items-center gap-2">
              <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary">VS</span>
              <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap">
                {match?.matchType}
              </span>
            </div>
            
            <div className="flex-1 text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 mx-auto mb-2 md:mb-3 rounded-full overflow-hidden bg-muted">
                <Image 
                  src={match?.team2?.flag} 
                  alt={match?.team2?.flagAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground">
                {match?.team2?.name}
              </h3>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 text-sm md:text-base text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} />
              <span>{match?.date}</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-muted-foreground" />
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={16} />
              <span>{match?.time}</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-muted-foreground" />
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={16} />
              <span>{match?.venue}</span>
            </div>
          </div>
        </div>
        
        <div className={`lg:w-64 p-4 md:p-6 rounded-lg text-center ${isLocked ? 'bg-error/10' : 'bg-warning/10'}`}>
          <div className="flex items-center justify-center gap-2 mb-2">
            <Icon name={isLocked ? "Lock" : "Timer"} size={20} className={isLocked ? "text-error" : "text-warning"} />
            <span className="text-xs md:text-sm font-medium text-muted-foreground uppercase tracking-wide">
              {isLocked ? 'Locked' : 'Time Remaining'}
            </span>
          </div>
          <div className={`text-2xl md:text-3xl lg:text-4xl font-bold ${isLocked ? 'text-error' : 'text-warning'}`}>
            {formatTimeRemaining(timeRemaining)}
          </div>
          {!isLocked && (
            <p className="text-xs md:text-sm text-muted-foreground mt-2">
              {autoLockHours === 0
                ? 'Predictions lock before start of the match'
                : `Predictions lock ${autoLockHours} hour${autoLockHours !== 1 ? 's' : ''} before match`}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MatchHeader;